import './option.styles.scss';

const Option = ({icon, text}) => {


	return(
		<button>
			<span className='icon'>
				{icon}
			</span>
			<span className='title'>
				{text}
			</span>
		</button>
	);
}

export default Option;